import { connect } from 'react-redux'
import { sagaActions } from 'store/sagas'
import requestRemoveBookmark from 'store/sagas/requestRemoveBookmark'
import bookmarksSelector from './bookmarksSelector'
import Bookmarks from './Bookmarks'

export default connect(
  bookmarksSelector,
  {
    fetchBookmarks: sagaActions.fetchBookmarks,
    requestRemoveBookmark
  }
)(Bookmarks)
